import { JcLogoShortSpinner, JcPowerMoveSpinner } from "@/assets";
import { useTheme } from "@/contexts/theme-provider";
import { cn } from "@/lib/utils";
import JCLogoShortAsImg from "@/assets/jc-logo-short-deprecated.svg";
import JCLogoShortDarkModeAsImg from "@/assets/jc-logo-short-dark-mode-deprecated.svg";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlag } from "@/constants";

// Note that styles for spinner live in the root /index.html page, as they are used on the pages initial load
export const Spinner = ({
    sizing = "default",
    cover = true, // Covers the UI up to it's closest non-static ancestor (eg. a relative positioned parent)
    fadeOnExit = true,
    ...props
}: React.ComponentProps<typeof JcLogoShortSpinner> & {
    sizing?: "default" | "large" | "larger" | "largest";
    cover?: boolean;
    fadeOnExit?: boolean;
}) => {
    const { outputTheme } = useTheme();
    const size =
        sizing === "large"
            ? { height: 56, width: 56 }
            : sizing === "larger"
              ? { height: 100, width: 100 }
              : sizing === "largest"
                ? { height: 150, width: 150 }
                : undefined;

    const flags = useFlags();

    return !flags[FeatureFlag.IL_4194_POWER_MOVE] ? (
        <div
            className={cn(
                "animate-spinner",
                cover &&
                    "bg-blanket-subtle rounded-default absolute inset-0 z-10 flex h-full w-full items-center justify-center backdrop-blur-xs",
                fadeOnExit && "animate-out fade-out",
            )}
        >
            <img
                src={
                    outputTheme === "dark"
                        ? JCLogoShortDarkModeAsImg
                        : JCLogoShortAsImg
                }
                className="original-path absolute"
                {...size}
            />
            <JcLogoShortSpinner {...size} {...props} />
        </div>
    ) : (
        <div
            className={cn(
                "animate-power-move",
                cover &&
                    "bg-blanket-subtle rounded-default absolute inset-0 z-10 flex h-full w-full items-center justify-center backdrop-blur-xs",
                fadeOnExit && "animate-out fade-out",
            )}
        >
            <JcPowerMoveSpinner {...size} {...props} />
        </div>
    );
};
